/* MXDVS cookie consent: white glass terminal.
   Stores the choice through Shopify's Customer Privacy API.
   07.10.2026: the cookie-bite effect is removed entirely (no bites, crumbs, falling pieces or integrity counter).
   10.10.2026: switches start OFF until the visitor has chosen; a saved choice (Deny too) keeps the window closed on the next page.
   12.10.2026: on the Instagram door links (/ig, /igs) the window fades in 5 seconds after the container door has opened. */
(function(){
  'use strict';

  var LS_KEY='mxcc_consent_v1';
  var GL='ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*+=<>';
  var reduced=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var qa=function(s,r){return Array.prototype.slice.call(r.querySelectorAll(s))};

  /* ---------- Instagram container door (snippets/mxdvs-ig-preload.liquid) ----------
     The snippet sets window.MXDVS_IG_PRE when the door plays on this page view; the door
     sends mxdvs:preload-done once it has opened (also when skipped or with reduced motion). */
  var DOOR_WAIT=5000;
  var doorDone=false;
  document.addEventListener('mxdvs:preload-done',function(){doorDone=true});
  function doorBusy(){
    var c=document.documentElement.classList;
    return c.contains('mxdvs-ig-pre')||c.contains('mxdvs-ig-play')||!!document.querySelector('.mxdvs-ig-ov')||!window.MXDVS_IG_STARTED;
  }
  /* door visit: run cb 5 s after the door has opened and return true; otherwise return false */
  function afterDoor(cb){
    if(!window.MXDVS_IG_PRE) return false;
    var fired=false;
    function go(){if(fired) return;fired=true;setTimeout(cb,DOOR_WAIT)}
    if(doorDone||!doorBusy()){go();return true}
    document.addEventListener('mxdvs:preload-done',go);
    setTimeout(go,12000); // the door never reported back (script failed): open anyway
    return true;
  }

  /* ---------- Shopify Customer Privacy API ---------- */
  var privacy=null,privacyWaiters=[],privacyLoading=false;
  function withPrivacy(cb){
    if(privacy||!window.Shopify){cb(privacy);return}
    if(window.Shopify.customerPrivacy){privacy=window.Shopify.customerPrivacy;cb(privacy);return}
    privacyWaiters.push(cb);
    if(privacyLoading) return;
    privacyLoading=true;
    function done(){var w=privacyWaiters;privacyWaiters=[];w.forEach(function(f){f(privacy)})}
    if(typeof window.Shopify.loadFeatures!=='function'){done();return}
    try{
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){
        if(!err&&window.Shopify.customerPrivacy) privacy=window.Shopify.customerPrivacy;
        done();
      });
    }catch(e){done()}
  }
  function readStored(){try{return JSON.parse(localStorage.getItem(LS_KEY))}catch(e){return null}}
  function currentConsent(){
    var c={preferences:false,analytics:false,marketing:false};
    if(privacy&&typeof privacy.currentVisitorConsent==='function'){
      try{
        var v=privacy.currentVisitorConsent()||{};
        c.preferences=v.preferences==='yes';c.analytics=v.analytics==='yes';c.marketing=v.marketing==='yes';
        return c;
      }catch(e){}
    }
    var st=readStored();
    if(st){c.preferences=!!st.preferences;c.analytics=!!st.analytics;c.marketing=!!st.marketing}
    return c;
  }
  /* what the switches show when the window opens: every switch is OFF until
     the visitor has chosen (Shopify can report yes by default in some regions) */
  function startConsent(){
    if(readStored()) return currentConsent();
    return {preferences:false,analytics:false,marketing:false};
  }
  function hasDecided(){
    if(privacy&&typeof privacy.currentVisitorConsent==='function'){
      try{var v=privacy.currentVisitorConsent()||{};if(v.analytics||v.marketing||v.preferences) return true}catch(e){}
    }
    return !!readStored();
  }

  /* ---------- decode text effect ---------- */
  function decode(el,txt,dur){
    if(!el) return;
    if(txt==null) txt=el.getAttribute('data-t')||el.textContent;
    el.setAttribute('data-t',txt);
    if(el._mxccRaf) cancelAnimationFrame(el._mxccRaf);
    if(reduced){el.textContent=txt;return}
    var start=performance.now();dur=dur||700;
    (function f(t){
      var k=Math.min(1,(t-start)/dur),out='';
      for(var i=0;i<txt.length;i++){
        var ch=txt[i];
        out+=(/[A-Za-z0-9]/.test(ch)&&i>=k*txt.length)?GL[(Math.random()*GL.length)|0]:ch;
      }
      el.textContent=out;
      if(k<1) el._mxccRaf=requestAnimationFrame(f);
    })(start);
  }

  function init(root){
    if(!root||root._mxcc) return;
    root._mxcc=true;

    var C={};
    try{C=JSON.parse(root.querySelector('[data-mxcc-config]').textContent)}catch(e){}
    function num(k,d){var v=parseFloat(C[k]);return isNaN(v)?d:v}
    var cfg={openDelay:num('openDelay',1)};
    var design=!!(window.Shopify&&window.Shopify.designMode);

    /* move to <body> so no transformed parent can break position: fixed */
    if(root.parentNode!==document.body) document.body.appendChild(root);

    var wrap=root.querySelector('[data-mxcc-wrap]');
    var cc=root.querySelector('[data-mxcc-banner]');
    var setEl=root.querySelector('[data-mxcc-set]');
    var titleEl=cc.querySelector('[data-mxcc-title]');

    var state='closed',standalone=false;
    var consent={preferences:false,analytics:false,marketing:false};
    /* the state is also written on the element (data-mxcc-state) so the
       newsletter can always see whether this window is on screen:
       pending, open, settings, finishing or closed */
    function setState(v){state=v;root.setAttribute('data-mxcc-state',v)}
    root.setAttribute('data-mxcc-state','pending');

    /* ---------- open / close ---------- */
    function renderToggles(){
      qa('[data-mxcc-cat]',setEl).forEach(function(b){
        var on=!!consent[b.getAttribute('data-mxcc-cat')];
        b.setAttribute('aria-pressed',on?'true':'false');
        b.textContent=on?'ON':'OFF';
      });
    }
    function showRoot(){
      root.hidden=false;
      wrap.classList.remove('is-gone','is-dim','is-in');
      document.dispatchEvent(new CustomEvent('mxcc:open'));
      setEl.classList.remove('is-open');
    }
    function openBanner(){
      standalone=false;
      consent=startConsent();renderToggles();
      showRoot();
      setState('open');
      requestAnimationFrame(function(){
        wrap.classList.add('is-in');
        decode(titleEl,null,800);
        qa('[data-mxcc-dec]',cc).forEach(function(s,i){setTimeout(function(){decode(s,null,600)},250+i*200)});
        var first=cc.querySelector('[data-mxcc-act="accept"]');
        if(first) try{first.focus({preventScroll:true})}catch(e){}
      });
    }
    function openSettings(alone){
      if(alone){
        consent=startConsent();renderToggles();
        showRoot();
        wrap.classList.add('is-gone');
        standalone=true;
      }else{
        wrap.classList.add('is-dim');
      }
      setState('settings');
      setEl.classList.add('is-open');
      decode(setEl.querySelector('[data-mxcc-set-title]'),null,700);
      var first=setEl.querySelector('[data-mxcc-act="deny"]');
      if(first) try{first.focus({preventScroll:true})}catch(e){}
    }
    function closeSettings(){
      setEl.classList.remove('is-open');
      if(standalone){hideAll();return}
      wrap.classList.remove('is-dim');
      setState('open');
    }
    function hideAll(){
      setState('closed');
      document.dispatchEvent(new CustomEvent('mxcc:closed'));
      setTimeout(function(){if(state==='closed') root.hidden=true},900);
    }
    function saveConsent(v){
      var data={preferences:!!v.preferences,analytics:!!v.analytics,marketing:!!v.marketing,at:Date.now()};
      try{localStorage.setItem(LS_KEY,JSON.stringify(data))}catch(e){}
      function fire(){document.dispatchEvent(new CustomEvent('mxcc:consent',{detail:data}))}
      if(design){fire();return}
      withPrivacy(function(p){
        if(p&&typeof p.setTrackingConsent==='function'){
          try{
            p.setTrackingConsent({analytics:data.analytics,marketing:data.marketing,preferences:data.preferences,sale_of_data:data.marketing},fire);
          }catch(e){fire()}
        }else fire();
      });
    }
    function finish(v){
      if(state==='finishing'||state==='closed') return;
      saveConsent(v);
      if(standalone){setEl.classList.remove('is-open');hideAll();return}
      setState('finishing');
      setEl.classList.remove('is-open');
      wrap.classList.remove('is-dim');
      wrap.classList.add('is-gone');
      hideAll();
    }

    root.addEventListener('click',function(e){
      var t=e.target.closest('[data-mxcc-act],[data-mxcc-cat]');
      if(!t||!root.contains(t)) return;
      if(t.hasAttribute('data-mxcc-cat')){
        var k=t.getAttribute('data-mxcc-cat');consent[k]=!consent[k];
        t.setAttribute('aria-pressed',consent[k]?'true':'false');
        decode(t,consent[k]?'ON':'OFF',350);
        return;
      }
      switch(t.getAttribute('data-mxcc-act')){
        case 'accept':finish({preferences:true,analytics:true,marketing:true});break;
        case 'deny':finish({preferences:false,analytics:false,marketing:false});break;
        case 'save':finish(consent);break;
        case 'manage':openSettings(false);break;
        case 'back':closeSettings();break;
      }
    });
    root.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&state==='settings') closeSettings();
    });

    /* links anywhere on the site can reopen the settings:
       href="#cookie-settings" or a data-mxcc-open attribute */
    function onReopen(e){
      var a=e.target.closest&&e.target.closest('a[href="#cookie-settings"],[data-mxcc-open]');
      if(!a) return;
      e.preventDefault();
      withPrivacy(function(){openSettings(true)});
    }
    document.addEventListener('click',onReopen);

    root._mxccDestroy=function(){
      document.removeEventListener('click',onReopen);
      root.remove();
    };

    /* ---------- decide whether to show ----------
       Other MXDVS pop-ups (newsletter) read window.MXCC_STATE or listen
       for mxcc:ready so they never open on top of this window. */
    function ready(shown){
      window.MXCC_STATE=shown?'open':'done';
      if(!shown) setState('closed');
      else if(state==='closed') setState('pending');
      document.dispatchEvent(new CustomEvent('mxcc:ready',{detail:{shown:shown}}));
    }
    document.addEventListener('mxcc:consent',function(){window.MXCC_STATE='done'});
    if(design){
      if(C.preview) openBanner();
      ready(!!C.preview);
      return;
    }
    window.MXCC_STATE='pending';
    withPrivacy(function(p){
      var show;
      if(C.showMode==='always') show=!hasDecided();
      else if(p&&typeof p.shouldShowBanner==='function'){
        try{show=p.shouldShowBanner()&&!readStored()}catch(e){show=!hasDecided()}
      }else show=!hasDecided();
      if(show&&!afterDoor(openBanner)) setTimeout(openBanner,Math.max(0,cfg.openDelay)*1000);
      ready(!!show);
    });
  }

  function boot(){qa('[data-mxcc]',document).forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();

  /* theme editor: rebuild when the section is edited, clean up when removed */
  document.addEventListener('shopify:section:load',function(e){
    qa('[data-mxcc]',document).forEach(function(r){
      if(r.getAttribute('data-section-id')===e.detail.sectionId&&r._mxcc&&!e.target.contains(r)) r._mxccDestroy();
    });
    var fresh=e.target.querySelector('[data-mxcc]');
    if(fresh) init(fresh);
  });
  document.addEventListener('shopify:section:unload',function(e){
    qa('[data-mxcc]',document).forEach(function(r){
      if(r.getAttribute('data-section-id')===e.detail.sectionId&&r._mxccDestroy) r._mxccDestroy();
    });
  });
})();
